
export class UserInfo {
    name: string | null = null;
    login: string | null = null;
    email: string | null = null;
    roles: string[] | null = null;
    isAuthorized: boolean = false;
    appUserRoles:  AppUserRoles[] | null = null;

    constructor(init?: Partial<UserInfo>) {
        Object.assign(this, init);
    }
}

export class AppUserRoles {
    appId: string | null = null;
    roles: string[] | null = null;
    isApp:  boolean | null = null;
    url: string | null = null;

    constructor(init?: Partial<AppUserRoles>) {
        Object.assign(this, init);
    }
}